module.exports = __webpack_public_path__ + "img/shieldGif.552daef0.gif";